import type { ChildDom } from "vanjs-core";

export interface ViewComponent {
	ChildDom: ChildDom;
}

function afterNextRepaint(callback: () => void): void {
	requestAnimationFrame(() => requestAnimationFrame(() => callback()));
}

export function scrollIntoView(c: ChildDom): void {
	if (!(c instanceof HTMLElement)) throw "ChildDom is not an html element";
	if (!c.isConnected) throw "ChildDom is not connected";
	afterNextRepaint(() =>
		c.scrollIntoView({
			behavior: "smooth",
			block: "center",
			inline: "center",
		}),
	);
}

export function scrollToTop(): void {
	afterNextRepaint(() =>
		window.scrollTo({
			top: 0,
			behavior: "smooth",
		}),
	);
}
